import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'age',
  standalone: true
})
export class AgePipe implements PipeTransform {
  // A year's VB minimum is worked out on the age on 1 January of that year
  transform(value: string | Date | null | undefined, onJanuaryFirstOf?: number | null): string | number {
    if (!value) return '';

    const birthDate = moment.utc(value);

    if (!birthDate.isValid()) return '';

    const asOf = onJanuaryFirstOf ? moment.utc({ year: onJanuaryFirstOf, month: 0, date: 1 }) : moment();
    return asOf.diff(birthDate, 'years');
  }
}
